import 'swiper/css'
import { Autoplay } from 'swiper/modules'

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'

import Container from '@components/Layout/Container'
import Section from '@components/Layout/Section'

import * as styles from './Awards.module.scss'

type Data = {
	wp: {
		themeSettings: {
			themeSettings: {
				awardsTitle: string
				awardsGallery: {
					localFile: {
						publicURL: string
						childImageSharp: {
							gatsbyImageData: IGatsbyImageData
						}
					}
				}[]
			}
		}
	}
}

const Awards: React.FC = () => {
	const data = useStaticQuery<Data>(graphql`
		query AwardsData {
			wp {
				themeSettings {
					themeSettings {
						awardsTitle
						awardsGallery {
							...wpMediaItem
							localFile {
								childImageSharp {
									gatsbyImageData(width: 350)
								}
							}
						}
					}
				}
			}
		}
	`)

	const content = data.wp.themeSettings.themeSettings

	return (
		<Section className={styles.section} hasContainer={false}>
			<Container>
				<h2 className={styles.title}>{content.awardsTitle}</h2>
			</Container>

			{content.awardsGallery.length ? (
				<Container className={styles.sliderContainer}>
					<Swiper
						modules={[Autoplay]}
						className={styles.awards}
						slidesPerView={1.4}
						centeredSlides
						spaceBetween={16}
						autoHeight
						autoplay={{
							delay: 0,
							pauseOnMouseEnter: true,
						}}
						speed={5000}
						breakpoints={{
							768: {
								slidesPerView: 2.4,
								centeredSlides: false,
							},
							1024: {
								slidesPerView: 4,
								centeredSlides: true,
								loop: true,
								spaceBetween: 32,
							},
							1280: {
								slidesPerView: 6,
								centeredSlides: true,
								loop: true,
								spaceBetween: 32,
							},
							1440: {
								slidesPerView: 8,
								centeredSlides: true,
								loop: true,
								spaceBetween: 32,
							},
						}}
					>
						{content.awardsGallery.map((award, i) => {
							return (
								<SwiperSlide className={styles.award} key={i}>
									<GatsbyImage image={award.localFile.childImageSharp.gatsbyImageData} alt="" />
								</SwiperSlide>
							)
						})}
					</Swiper>
				</Container>
			) : null}
		</Section>
	)
}

export default Awards
